import { isNullOrUndefined } from './utils';

/**
 * Converts a key/value pair object to a querystring.
 *
 * If a value is `null` or `undefined` an empty string will be applied instead.
 * @param query
 */
export const toQuerystring = (query: Object) => {
  const qs = Object.entries(query)
    .map(([key, value]) => `${key}=${!isNullOrUndefined(value) ? value : ''}`)
    .join('&');
  return qs ? `?${qs}` : '';
};
